import React, { useEffect, useState } from "react";
import { SearchIcon } from "~/assets/svg/InterfaceIcon";
import roundImg from "~/assets/img/vq_thumb.jpg";
import logoImg from "~/assets/img/defaultImg/light-logo-square.png";
import gitbalLogoImg from "~/assets/img/logo-black.svg";
import useRequest from "~/common/hooks/useRequest";
import { API_STATE } from "~/common/constants/state";
import { useGlobalStore } from "~/store";
import { useNavigate, useParams } from "react-router";
import storageService from "~/utils/storage";
import { dateToString } from "~/utils/formatter";
import Pagination from "~/common/components/Pagination";

const List = ({ userNm, handleGo }) => {
	const navigate = useNavigate();
	const params = useParams();
	const listRequest = useRequest("post", "/vc/round/external/review/list", "gitbal", true);
	const [list, setList] = useState();
	const [roundInfo, setRoundInfo] = useState();
	const [titleSearch, setTitleSearch] = useState();
	const [, dispatch] = useGlobalStore();
	const [totalPage, setTotalPage] = useState(1);
	const [pageNumber, setPageNumber] = useState(0);

	const doSearch = () => {
		listRequest.call({
			name: titleSearch,
			page: 1,
			size: 10,
		});
	};

	useEffect(() => {
		listRequest.call({
			name: "",
			page: 1,
			size: 10,
		});
	}, []);

	const handleLogout = () => {
		storageService.clear("external", "local");
		navigate(`/externalRound/${params.idx}`);
	};

	useEffect(() => {
		switch (listRequest.state) {
			case API_STATE.done:
				const { list, round } = listRequest.response.data;
				setTotalPage(listRequest.response.data.pagination.totalPage);
				setPageNumber(listRequest.response.data.pagination.page);
				setList(list);
				setRoundInfo(round);
				break;
			case API_STATE.error:
				alert("다시 로그인 해주시기 바랍니다.");
				console.log("loginRequest.error >>> ", listRequest.error);
				handleLogout();
				break;
			default:
				break;
		}
	}, [listRequest.state, listRequest.error, listRequest.response]);

	return (
		<div className="external-evaluate-wrap">
			<header className="external-header">
				<div className="header-content">
					<div className="img-wrap">
						<a href={"https://gitbal.io"} target={"_blank"} rel="noopener noreferrer">
							<img src={gitbalLogoImg} alt="logo" />
						</a>
					</div>
					<div className="header-btn">
						<h4 className="external-judge-name">{userNm}</h4>
						<button type="button" className="btn-ghost" onClick={() => handleLogout()}>
							로그아웃
						</button>
					</div>
				</div>
			</header>
			<div className="external-evaluate">
				<div className="evaluate-card">
					<div className="c__card left">
						<div className="img-wrap">
							<img src={roundInfo?.img || roundImg} alt={"지원 프로그램 이미지"} />
						</div>
						<div className="round-info">
							<h3 className="round-title">{roundInfo?.title}</h3>
							<div className="row">
								<p className="round-apply-date">
									지원기간 : {dateToString(roundInfo?.startDate, "yyyy-MM-dd")} ~{" "}
									{dateToString(roundInfo?.endDate, "yyyy-MM-dd")}
								</p>
								<p>주체 : {roundInfo?.companyName}</p>
							</div>
							<span className="divider" />
							<div className="state-wrap">
								<dl className="round-state">
									<dt>참가기업</dt>
									<dd>{list?.length}</dd>
								</dl>
								<dl className="evaluate-state">
									<dt>심사완료</dt>
									<dd>{roundInfo?.applyCount}</dd>
								</dl>
							</div>
						</div>
					</div>
					<div className="apply-result-wrap">
						<div className="c__card right">
							<div className="c__table">
								<div className="list-top">
									<div className="c__search">
										<input
											value={titleSearch}
											className="c__input"
											placeholder="기업명을 입력하세요."
											onChange={(e) => setTitleSearch(e.target.value)}
											onKeyDown={(e) => {
												if (e.key === "Enter") {
													doSearch();
												}
											}}
										/>
										<button
											type="button"
											className="btn-search"
											onClick={doSearch}
										>
											<SearchIcon />
										</button>
									</div>
								</div>
								<div className="thead">
									<div className="tr">
										<div className="th company-num">No</div>
										<div className="th company-profile">기업명</div>
										<div className="th company-ceo">대표</div>
										<div className="th company-kind">기업정보</div>
										<div className="th company-status">상태</div>
										<div className="th company-evaluate">심사</div>
									</div>
								</div>
								<div className="tbody">
									{list?.map((d, idx) => (
										<div
											key={idx}
											className="tr"
											onClick={() => handleGo(d.idx)}
										>
											<div className="td company-num">1</div>
											<div className="td company-profile">
												<div className="img-wrap">
													<img
														src={d.logoSqu || logoImg}
														alt="회사로고"
													/>
												</div>
												<div className="company-name">{d.companyName}</div>
											</div>
											<div className="td company-ceo">{d.ceoName}</div>
											<div className="td company-kind">{d.business}</div>
											<div
												className={`td company-status ${
													d.status === "심사대기" ? "standBy" : ""
												}`}
											>
												{d.status === "심사대기" ? "심사대기" : "심사완료"}
											</div>
											<div className="td company-evaluate">
												<button
													type="button"
													className="btn__outline angled"
													color="primary"
												>
													심사하기
												</button>
											</div>
										</div>
									))}
								</div>
							</div>
							<Pagination
								setPageNumber={setPageNumber}
								currentPage={pageNumber}
								totalPage={totalPage}
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default List;
